<form
    class="detail-page-card-body padded cerrix-control-sm form-group-styling"
    [formGroup]="parentForm"
    novalidate
>
    <div class="detail-page-card">
        <div class="detail-page-card-title">
            {{ "detailMain.periodDetailsTitle" | t }}
        </div>
        <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
            <div class="row">
                <div class="col-12 col-xl-6 left-block">
                    <div class="row">
                        <div class="form-group col">
                            <cerrix-textfield
                                [fieldLabel]="'detailMain.periodNameLabel' | t"
                                dataUiid="auditperiodsdetailmain-name"
                                formControlName="name"
                                identifier="periodNameInput"
                                [required]="true"
                            ></cerrix-textfield>
                        </div>
                        <div class="row">
                            <div class="form-group col-6">
                                <label for="StartDate">{{
                                    "detailMain.dateClosedLabel" | t
                                }}</label>
                                <date-input
                                    data-uiid="auditperiodsdetailmain-dateclosed"
                                    [disabled]="true"
                                    [value]="model.dateClosed"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Right block -->
                <div class="col-12 col-xl-6 right-block">
                    <div class="row">
                        <div class="form-group col-6">
                            <label for="StartDate">{{
                                "detailMain.startDateLabel" | t
                            }}</label>
                            <date-input
                                data-uiid="auditperiodsdetailmain-startdate"
                                formControlName="startDate"
                            ></date-input>
                        </div>
                        <div class="form-group col-6">
                            <label for="EndDate">{{
                                "detailMain.endDateLabel" | t
                            }}</label>
                            <date-input
                                data-uiid="auditperiodsdetailmain-enddate"
                                formControlName="endDate"
                            ></date-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <!-- generic-list-manager reads its config only once, so re-create it for each new config. -->
        @for (config of [auditUniverseConfig]; track config) {
            @if (config) {
                <generic-list-manager [config]="config"></generic-list-manager>
            }
        }
    </div>
</form>
